import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CompanyPage from "../pages/company/page";
import PolicyPage from "../pages/policy/page";
import HealthPage from "../pages/health/page";
import SecurityPage from "../pages/security/page";
import ServicePage from "../pages/service/page";
import RecordPage from "../pages/record/page";
import ContactPage from "../pages/contact/page";
import ITSupportPage from "../pages/it-support/page";
import AccessPage from "../pages/access/page";
import RecruitPage from "../pages/recruit/page";
import ECDetailPage from "../pages/ec-detail/page";
import ProductsPage from "../pages/products/page";
import InterviewPage from "../pages/interview/page";
import HitotsuzuriPage from "../pages/hitotsuzuri/page";
import MskKnowledgeAiPage from "../pages/msk-knowledge-ai/page";
import SeslyPage from "../pages/sesly/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/company",
    element: <CompanyPage />,
  },
  {
    path: "/policy",
    element: <PolicyPage />,
  },
  {
    path: "/health",
    element: <HealthPage />,
  },
  {
    path: "/security",
    element: <SecurityPage />,
  },
  {
    path: "/service",
    element: <ServicePage />,
  },
  {
    path: "/record",
    element: <RecordPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/it-support",
    element: <ITSupportPage />,
  },
  {
    path: "/access",
    element: <AccessPage />,
  },
  {
    path: "/recruit",
    element: <RecruitPage />,
  },
  {
    path: "/ec-detail",
    element: <ECDetailPage />,
  },
  {
    path: "/products",
    element: <ProductsPage />,
  },
  {
    path: "/interview",
    element: <InterviewPage />,
  },
  {
    path: "/hitotsuzuri",
    element: <HitotsuzuriPage />,
  },
  {
    path: "/msk-knowledge-ai",
    element: <MskKnowledgeAiPage />,
  },
  {
    path: "/products/sesly",
    element: <SeslyPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;